<template>
  <t-layout :showNav="false">
    <div class="page" v-if="detail">
      <div v-if="detail.info" class="content">
        <div class="icon">
          <img :src="detail.info.img" />
        </div>
        <div class="info">
          <div class="title">{{ detail.info.title }}</div>
          <div class="sub-title">{{ detail.info.points }}移动积分</div>
        </div>
        <div class="num">x{{ detail.info.num }}</div>
      </div>

      <div v-if="!!detail.coupon_list && !!detail.coupon_list.length" class="wrap">
        <div class="title">
          <div class="text">彩票券码</div>
          <div class="btn" @click="toExchange">去领取</div>
        </div>
        <div class="list">
          <div class="item" v-for="(item, index) in detail.coupon_list" :key="index">
            <div class="num">{{ item.coupon_code }}</div>
            <div class="copy" @click="copyCode(item.coupon_code)">复制</div>
          </div>
        </div>
      </div>

      <div class="wrap">
        <div class="title">
          <div class="text">购乐帮积分</div>
          <!-- <div class="btn default" @click="toMall">去查看</div> -->
        </div>
        <div class="list">
          <div class="item">
            <div class="num">{{ detail.points }}积分</div>
          </div>
        </div>
      </div>

      <div class="wrap" v-if="detail.info">
        <div class="list list-cell">
          <div class="item">
            <div class="num">订单编号</div>
            <div class="value copyIcon" @click="copyCode(detail.info.order_no)">
              {{ detail.info.order_no }}
            </div>
          </div>
          <div class="item">
            <div class="num">下单时间</div>
            <div class="value">{{ detail.info.created_at }}</div>
          </div>
        </div>
      </div>
    </div>
  </t-layout>
</template>

<script>
export default {
  name: 'activityLotteryDetail',
  components: {},
  data() {
    return {
      id: 0,
      detail: {}
    }
  },

  activated() {
    this.$store.commit('setTitle', '兑换详情')
    const options = this.$route.query
    this.id = Number(options.id) || 0
    this.getDetail()
  },

  methods: {
    getDetail() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })

      this.$api.lotteryPoints
        .lotteryPointsOrderInfo({ id: this.id })
        .then(result => {
          let res = result.data
          if (res.code == 0) {
            this.detail = res.data
          }
        })
        .finally(() => {
          this.$toast.clear()
        })
    },

    toExchange() {
      this.$router.push({
        path: `/lottery/exchange`
      })
    },

    copyCode(value) {
      if (value) {
        this.$copyText(value)
          .then(e => {})
          .catch(e => {
            console.log(e)
          })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  color: #353738;
  background: #f9fafb;
  padding-bottom: 200rpx;
  min-height: 100vh;
}

.content {
  width: 100%;
  margin: 20rpx 0;
  background: #fff;
  padding: 24rpx 32rpx;
  display: flex;
  align-items: center;

  .icon {
    width: 150rpx;
    height: 150rpx;
    margin-right: 16rpx;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .info {
    flex: 1;
    .title {
      margin-bottom: 46rpx;
      font-size: 30rpx;
      line-height: 30rpx;
    }

    .sub-title {
      line-height: 26rpx;
      font-size: 26rpx;
      color: #ff5566;
    }
  }

  .num {
    color: #a1a7ad;
    font-size: 26rpx;
    line-height: 26rpx;
    width: 50rpx;
    text-align: right;
    padding-top: 80rpx;
  }
}

.wrap {
  padding: 40rpx 32rpx;
  background: #fff;
  margin-bottom: 24rpx;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32rpx;

    .text {
      font-size: 26rpx;
      line-height: 26rpx;
      font-weight: 500;
    }

    .btn {
      width: 104rpx;
      height: 40rpx;
      border-radius: 8rpx;
      box-shadow: 0 0 0 2rpx rgba(255, 85, 102, 0.5);
      color: #ff5566;
      font-size: 26rpx;
      line-height: 40rpx;
      text-align: center;

      &.default {
        color: #a1a7ad;
        box-shadow: 0 0 0 2rpx rgba(161, 167, 173, 0.5);
      }
    }
  }

  .list {
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 26rpx;
      line-height: 26rpx;
      margin-bottom: 32rpx;

      .num {
        color: #808991;
      }
      .copy {
        width: 100rpx;
        text-align: right;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    &.list-cell {
      .item {
        line-height: 48rpx;

        .value {
          color: #808991;
        }

        .copyIcon {
          padding-right: 52rpx;
          background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/mall/order/icon-copy.png');
          background-position: center right;
          background-repeat: no-repeat;
          background-size: 48rpx 48rpx;
        }
      }
    }
  }
}

.fix-bottom {
  width: 100%;
  padding-bottom: 12rpx;
  background: #fff;
  position: fixed;
  z-index: 9;
  right: 0;
  bottom: 0;

  .btn {
    height: 108rpx;
    text-align: center;
    font-size: 34rpx;
    font-weight: 500;
    line-height: 108rpx;
    color: #a1a7ad;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      display: block;
      width: 32rpx;
      height: 32rpx;
      margin-right: 8rpx;
    }
  }
}
</style>
